import { onDocumentReady } from '../utils/events';

onDocumentReady(() => {
  const menuButton = document.querySelector('.menu-icon');
  const menu = document.getElementById('main-menu');
  const body = document.getElementsByTagName('body')[0];

  menuButton.addEventListener('click', () => {
    menuButton.classList.toggle('is-active');
    menu.classList.toggle('is-active');
    body.classList.toggle('blocked');
  });
});
